import { TableBody } from 'components/Table/TableBody/TableBody';
import { queryKeys, queryParams } from 'utils/query';
import { getReports } from 'services/user';
import { ReportsListColumns } from 'components/Table/Columns/ReportsListColumns';
import { ReportsListFilters } from 'components/Table/Filters/ReportsListFilters';
import { TableConfig } from 'models/general';
import { useReportDownload } from 'hooks/api/useReports';
import { useEffect } from 'react';
import { useParameters } from 'hooks/useParameters';
import { ReportsStatus, ReportsTableItem } from 'utils/models';

const reportsListConfig: TableConfig = {
  queryKey: queryKeys.reports,
  defaultFilters: {
    [queryParams.status]: ReportsStatus.All,
  },
};

export const ReportsTable = () => {
  const { mutate: downloadReport, isPending } = useReportDownload();
  const { parameters: filters, setParameters } = useParameters();

  useEffect(() => {
    if (filters.reportId && !isPending) {
      downloadReport(filters.reportId);
      setParameters({ ...filters, reportId: '' });
    }
  }, [filters, downloadReport, isPending, setParameters]);

  return (
    <TableBody<ReportsTableItem>
      getData={getReports}
      getColumns={ReportsListColumns}
      config={reportsListConfig}
      filterBar={<ReportsListFilters config={reportsListConfig} searchByName={true} />}
    />
  );
};
